<template>
  <div>
    <selectYearChampion />
    <div class="champion">
      <div class="header-bg">
        <img
          v-if="headType === '1'"
          src="../assets/Male/2_Links/standings-bg.jpg"
          alt=""
        />
        <img
          v-if="headType === '2'"
          src="../assets/Female/2_Links/bg.jpg"
          alt=""
        />
        />
      </div>
      <div class="champion-con">
        <p
          class="cham-tit"
          :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
        >
          {{ $t("champion.GrandFinal") }}
        </p>
        <!-- grade start -->

        <!-- grate stop -->
        <!-- team-grade start -->
        <div class="team-grade" v-if="championInfo">
          <div class="grade">
            <p class="number">
              {{ championInfo.first_team_grade }} :
              {{ championInfo.second_team_grade }}
            </p>
          </div>
          <div class="team-left">
            <div class="team-img">
              <div class="img-bg">
                <img :src="championInfo.first_team.temp_icon_path_url" alt="" />
              </div>
              <p class="team-name">{{ championInfo.first_team_name }}</p>
              <p
                class="view-more"
                @click="
                  viewCom(championInfo.championId, championInfo.first_team_id)
                "
              >
                {{ $t("champion.viewmore") }}
              </p>
            </div>
          </div>
          <div class="team-right">
            <div class="team-img">
              <div class="img-bg">
                <img
                  :src="championInfo.second_team.temp_icon_path_url"
                  alt=""
                />
              </div>
              <p class="team-name">{{ championInfo.second_team_name }}</p>
              <p
                class="view-more"
                @click="
                  viewCom(championInfo.championId, championInfo.second_team_id)
                "
              >
                {{ $t("champion.viewmore") }}
              </p>
            </div>
            <div class="triangle"></div>
          </div>
        </div>
        <!-- <div class="coming">
          <h2>{{$t('home.nodata')}}</h2>
        </div> -->
        <div v-if="teamId == championInfo.first_team_id">
          <div class="champion-detial" v-show="viewShow">
            <ViewMore
              v-loading="championloading"
              :TeamMember="firstTeamMember"
              :headList="headList"
              :numList="firstNumList"
              :MemberList="firstMemberList"
              :MemberStats="firstMemberStats"
              :TeamInfo="firstTeamInfo"
              :championInfo="championInfo.first_team_grade"
              @close="close"
            />
          </div>
        </div>
        <div v-if="teamId == championInfo.second_team_id">
          <div class="champion-detial" v-show="viewShow">
            <ViewMore
              v-loading="championloading"
              :TeamMember="secondTeamMember"
              :headList="headList"
              :numList="secondNumList"
              :MemberList="firstMemberList"
              :MemberStats="secondMemberStats"
              :TeamInfo="secondTeamInfo"
              :championInfo="championInfo.second_team_grade"
              @close="close"
            />
          </div>
        </div>
        <!-- team-grade stop -->
        <!-- final mvp start -->
        <div class="final-MVP">
          <div class="average">
            <p
              class="champion-tit"
              :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
            >
              {{ $t("champion.average") }}
            </p>
            <div class="average-num" v-if="championInfo">
              <div class="line">
                <div class="line-info">
                  <span>{{ championInfo.first_team_member_total.POINTS }}</span>
                  <span>POINTS</span>
                  <span>{{
                    championInfo.second_team_member_total.POINTS
                  }}</span>
                </div>
                <div class="isline points-line">
                  <p
                    :class="['red-line', { 'red-line-girl': headType === '2' }]"
                  ></p>
                  <p
                    :class="[
                      'black-line',
                      { 'black-line-girl': headType === '2' }
                    ]"
                  ></p>
                </div>
              </div>
              <div class="line">
                <div class="line-info">
                  <span>{{
                    championInfo.first_team_member_total.ASSISTS
                  }}</span>
                  <span>ASSISTS</span>
                  <span>{{
                    championInfo.second_team_member_total.ASSISTS
                  }}</span>
                </div>
                <div class="isline assists-line">
                  <p
                    :class="['red-line', { 'red-line-girl': headType === '2' }]"
                  ></p>
                  <p
                    :class="[
                      'black-line',
                      { 'black-line-girl': headType === '2' }
                    ]"
                  ></p>
                </div>
              </div>

              <div class="line">
                <div class="line-info">
                  <span>{{
                    championInfo.first_team_member_total.REBOUNDS
                  }}</span>
                  <span>REBOUNDS</span>
                  <span>{{
                    championInfo.second_team_member_total.REBOUNDS
                  }}</span>
                </div>
                <div class="isline rebound-line">
                  <p
                    :class="['red-line', { 'red-line-girl': headType === '2' }]"
                  ></p>
                  <p
                    :class="[
                      'black-line',
                      { 'black-line-girl': headType === '2' }
                    ]"
                  ></p>
                </div>
              </div>
            </div>
          </div>
          <div class="mvp-info" v-if="championInfo">
            <p
              class="champion-tit"
              :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
            >
              {{ $t("champion.mvp") }}
            </p>
            <div class="info">
              <div class="img">
                <img :src="championInfo.FMVP.icon_path" alt="" />
              </div>
              <div class="info-box">
                <div class="name-grade">
                  <p class="en-name">
                    {{ championInfo.FMVP.team_name }}
                    · {{ championInfo.FMVP.number }}
                  </p>
                  <p class="cn-name">{{ championInfo.FMVP.name }}</p>
                </div>
                <div class="mvp-num">
                  <div class="num-box">
                    <p class="num-name">PTS</p>
                    <p
                      class="num"
                      :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
                    >
                      {{ championInfo.FMVP.PTS }}
                    </p>
                  </div>
                  <div class="num-box">
                    <p class="num-name">AST</p>
                    <p
                      class="num"
                      :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
                    >
                      {{ championInfo.FMVP.AST }}
                    </p>
                  </div>
                  <div class="num-box">
                    <p class="num-name">REB</p>
                    <p
                      class="num"
                      :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
                    >
                      {{ championInfo.FMVP.REB }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- final mvp stop -->
        <!-- highlight start -->
        <div class="highlght-box">
          <p
            class="champion-tit"
            :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
          >
            {{ $t("champion.highlight") }}
          </p>
        </div>
        <Highlight
          :vediolink="vediolink_champion"
          :video="headType == '1' ? video : video_girl"
        />
        <!-- game-gallery start -->
        <div class="game-gallery">
          <div class="review-game" v-show="gaShow">
            <p
              class="champion-tit"
              :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
            >
              {{ $t("champion.back") }}
            </p>
            <div class="review-box">
              <div class="re-header">
                <div class="logo-img">
                  <img src="../assets/ihk-logo.png" alt="" />
                </div>
                <p class="re-tit">
                  {{ $t("champion.ihk") }}
                </p>
              </div>
              <div class="re-img">
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/-mrZFD2Fn4o"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <transition name="el-zoom-in-top">
            <div class="gallery" v-show="gaShow">
              <div class="gallery-header">
                <p
                  class="champion-tit"
                  :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
                >
                  {{ $t("champion.gallery") }}
                </p>
                <p
                  @click="showgallery"
                  class="see-all"
                  v-scroll-to="{
                    el: '#gallery-title',
                    duration: 500,
                    easing: 'ease',
                    offset: -50,
                    force: true,
                    cancelable: true
                  }"
                >
                  See All <i class="el-icon-right"></i>
                </p>
              </div>
              <!-- <div class="coming"><h2 v-text="watchImg != 0 ? '即將推出' : 'Coming Soon'"></h2></div> -->
              <div class="gallery-imgbox" v-if="championInfo">
                <div
                  class="gallery-img"
                  v-for="(item, index) in championInfo.covers"
                  :key="index"
                  v-loading="galleryloading"
                  element-loading-spinner="el-icon-loading"
                >
                  <el-image
                    class="img"
                    lazy
                    :src="item.temp_photo_path_url"
                    alt=""
                  >
                    <div slot="placeholder" class="image-slot">
                      <i class="el-icon-loading"></i></div
                  ></el-image>
                </div>
              </div>
            </div>
          </transition>

          <transition name="el-fade-in-linear">
            <div class="ga-com" v-show="galleryShow">
              <GalleryCom @toback="toback" :gallery="championInfo.gallery" />
            </div>
          </transition>
        </div>
        <!-- game-gallery stop -->
        <!-- Our media exposures start -->
        <div class="media-exposures">
          <p
            class="champion-tit"
            :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
          >
            {{ $t("champion.media") }}
          </p>
          <MediaCom :year="'2022'" :media-list="getMediaList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Highlight from "./components/HighlightVideo.vue";
import { BasketballApi } from "../api/basketball";
import { mapState } from "vuex";
import ViewMore from "./components/champion/ViewMore.vue";
import GalleryCom from "./components/champion/GalleryCom.vue";
import MediaCom from "./components/champion/MediaCom.vue";
import selectYearChampion from "../components/selectYearChampion.vue";

export default {
  components: {
    Highlight,
    ViewMore,
    GalleryCom,
    MediaCom,
    selectYearChampion
  },
  data() {
    return {
      galleryloading: false,
      watchImg: window.localStorage.getItem("watchImg") || 0,
      video: [{ title: "video_title2", text: "video_content2" }],
      video_girl: [{ title: "video_title2", text: "video_content2" }],
      vediolink_champion: "https://www.youtube.com/embed/s4KSkn71XDk",
      championloading: false,
      gaShow: true,
      galleryShow: false,
      viewShow: false,
      viewShow_right: false,
      yearvalue: "2022-23",
      boy_yearList: [
        {
          label: "2022-2023",
          value: "2023"
        },
        {
          label: "2021-2022",
          value: "2022"
        },
        {
          label: "2020-2021",
          value: "2021"
        }
      ],
      girl_yearList: [
        {
          label: "2022-2023",
          value: "2023"
        }
      ],
      championInfo_boy: {
        scheduleId: 6,
        championId: "",
        first_team_grade: "41",
        second_team_grade: "51",
        first_team_name: "鳳德野馬",
        second_team_name: "華富飛魚",
        first_team_id: 101,
        second_team_id: 108,
        first_team: {
          temp_icon_path_url: require("../assets/champion_info/fengde_mustang.png")
        },
        second_team: {
          temp_icon_path_url: require("../assets/Boys/splash.jpg")
        },
        first_team_member_total: {
          POINTS: "41",
          ASSISTS: "5",
          REBOUNDS: "26"
        },
        second_team_member_total: {
          POINTS: "51",
          ASSISTS: "43",
          REBOUNDS: "27"
        },
        FMVP: {
          icon_path: require("../assets/Boys/mvp2023.webp"),
          team_name: "華富飛魚",
          number: "13",
          name: "黎希樂",
          PTS: "14",
          AST: "1",
          REB: "17"
        },
        album_id: 266,
        covers: [],
        gallery: []
      },
      championInfo_girl: {
        scheduleId: 11,
        championId: "",
        first_team_grade: "42",
        second_team_grade: "29",
        first_team_name: "皇后山堡壘",
        second_team_name: "啟晴傾城",
        first_team_id: 110,
        second_team_id: 85,
        first_team: {
          temp_icon_path_url: require("../assets/Girls/champ_girl_2022.png")
        },
        second_team: {
          temp_icon_path_url: require("../assets/champion_info/qiqing_alure.png")
        },
        first_team_member_total: {
          POINTS: "42",
          ASSISTS: "9",
          REBOUNDS: "54"
        },
        second_team_member_total: {
          POINTS: "29",
          ASSISTS: "5",
          REBOUNDS: "45"
        },
        FMVP: {
          icon_path: require("../assets/Girls/mvp_girl_2022.webp"),
          team_name: "皇后山堡壘",
          number: "16",
          name: "王嘉雯",
          PTS: "21",
          AST: "1",
          REB: "3"
        },
        album_id: 268,
        covers: [],
        gallery: []
      },
      headList: [],
      firstNumList: [],
      secondNumList: [],
      firstTeamMember: [],
      secondTeamMember: [],
      firstMemberStats: [],
      secondMemberStats: [],
      firstMemberList: [],
      secondMemberList: [],
      firstTeamInfo: "",
      secondTeamInfo: "",
      teamId: "",
      mediaList: [
        {
          title: "media_title1",
          name: "media_name1",
          date: "media_date1",
          media_link:
            "https://www.sportsroad.hk/archives/419797?fbclid=IwAR1pnZxrwiTMfa6HU8GSd0DqR3TABk_IjCDmP49JRXTspXew9m_Y7At7v2U_aem_ARmrdlvw8TxrEmHxfUiU50j9mHxYCm5Gtrv5taIY6qKaH2b5gZ6FdEGm6Ozrqjnvi0U",
          media_img: require("../assets/media/media_2022_1.jpg")
        },
        {
          title: "media_title2",
          name: "media_name2",
          date: "media_date2",
          media_link:
            "https://hk.on.cc/hk/bkn/cnt/sport/20230624/bkn-20230624172816873-0624_00882_001.html",
          media_img: require("../assets/media/media_2022_2.jpg")
        },
        {
          title: "media_title3",
          name: "media_name3",
          date: "media_date3",
          media_link:
            "https://orientaldaily.on.cc/content/sport/odn-20230625-0625_00286_041/",
          media_img: require("../assets/media/media_2022_3.jpg")
        }
      ],
      mediaListGirl: [
        {
          title: "media_title1",
          name: "media_name1",
          date: "media_date1",
          media_link: "https://www.sportsroad.hk/archives/381380",
          media_img: require("../assets/media/mediagirl_2022.jpg")
        },
        {
          title: "media_title2",
          name: "media_name2",
          date: "media_date2",
          media_link:
            "https://www.sportsroad.hk/archives/419797?fbclid=IwAR1pnZxrwiTMfa6HU8GSd0DqR3TABk_IjCDmP49JRXTspXew9m_Y7At7v2U_aem_ARmrdlvw8TxrEmHxfUiU50j9mHxYCm5Gtrv5taIY6qKaH2b5gZ6FdEGm6Ozrqjnvi0U",
          media_img: require("../assets/media/mediagirl2_2022.jpg")
        },
        {
          title: "media_title3",
          name: "media_name3",
          date: "media_date3",
          media_link:
            "https://orientaldaily.on.cc/content/sport/odn-20230625-0625_00286_041/",
          media_img: require("../assets/media/media_2022_3.jpg")
        }
      ],
      boy_team_info: {},
      firl_team_info: {}
    };
  },
  computed: {
    ...mapState(["headType"]),
    getMediaList() {
      if (this.headType === "1") {
        return this.mediaList;
      } else {
        return this.mediaListGirl;
      }
    },
    championInfo() {
      if (this.headType === "1") {
        return this.championInfo_boy;
      } else {
        return this.championInfo_girl;
      }
    },
    yearVal() {
      if (this.headType == "1") {
        return this.boy_yearList;
      } else {
        return this.girl_yearList;
      }
    }
  },
  methods: {
    getHighlightAlbum() {
      BasketballApi.getHighlightAlbum(this.championInfo.album_id).then(
        (res) => {
          this.championInfo.covers = res.slice(0, 4);
          this.championInfo.gallery = res;
        }
      );
    },
    close() {
      this.viewShow = false;
      this.championInfo.championId = null;
    },
    showgallery() {
      this.galleryShow = !this.galleryShow;
      this.gaShow = !this.gaShow;
    },
    toback() {
      this.galleryShow = !this.galleryShow;
      this.gaShow = !this.gaShow;
    },
    viewCom(id, type) {
      this.championInfo.championId = id;
      this.teamId = type;
      this.viewShow = !this.viewShow;
      // this.getScheduleRoundsList();
    },
    getChampion() {
      this.championloading = true;
      this.galleryloading = true;
      this.headType;
      BasketballApi.getChampion().then((res) => {
        this.championInfo = res;
        this.championloading = false;
        this.galleryloading = false;
      });
    },
    getScheduleRoundsList() {
      BasketballApi.getScheduleRoundsList(
        "1",
        this.championInfo.scheduleId,
        "",
        "",
        "",
        "",
        "2023"
      ).then((res) => {
        this.roundsList = res.competitions;
        if (this.roundsList && this.roundsList[0]) {
          this.championInfo.championId = this.roundsList[0].id;
          this.getCompetitionDeatils();
        } else {
          this.championInfo.championId = [];
        }
      });
    },
    getCompetitionDeatils() {
      this.championloading = true;
      this.headType;
      BasketballApi.getCompetitionDeatils(this.championInfo.championId).then(
        (res) => {
          this.headList = Object.keys(res.first_team_member_total);
          this.firstNumList = res.first_team_member_total;
          this.secondNumList = res.second_team_member_total;
          this.firstTeamMember = res.first_team_members;
          this.secondTeamMember = res.second_team_members;
          this.firstTeamInfo = res.first_team;
          this.secondTeamInfo = res.second_team;
          let arr1 = [];
          let arr2 = [];
          let arr3 = [];
          let arr4 = [];
          res.first_team_members.forEach((item) => {
            this.list1 = Object.values(item);
            this.list2 = Object.keys(item);
            arr1.push(this.list1.slice(5, 20));
            arr2.push(this.list2.slice(5, 20));
          });
          res.second_team_members.forEach((item) => {
            this.list1 = Object.values(item);
            this.list2 = Object.keys(item);
            arr3.push(this.list1.slice(5, 20));
            arr4.push(this.list2.slice(5, 20));
          });
          this.firstMemberStats = res.first_team_members;
          this.firstMemberList = arr2;
          this.secondMemberStats = res.second_team_members;
          this.secondMemberList = arr4;
          this.secondTeamMember = res.second_team_members;
          this.championloading = false;
        }
      );
    }
  },
  created() {
    this.getHighlightAlbum();
    this.getScheduleRoundsList();
    // this.getChampion();
  }
};
</script>
<style lang="scss">
.champion {
  .el-image {
    .el-image__inner {
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
}
</style>
<style lang="scss" scoped>
.champion {
  background: #c5cfe348;
  padding-bottom: 70px;
  .coming {
    height: 200px;
    line-height: 100px;
    font-size: 30px;
    color: #e1e5eb9c;
  }
  .champion-tit {
    font-size: 25px;
    color: #5aa2d3;
    font-weight: 600;
    text-align: left;
    margin: 20px 35px;
  }
  .header-bg {
    height: 270px;
    img {
      width: 100%;
      height: 270px;
      object-fit: cover;
      object-position: top;
      // height: 100%;
    }
  }
  .champion-con {
    margin-top: -240px;
    width: 90%;
    margin-left: 5%;
    .grade {
      position: absolute;
      left: 45%;
      top: 33%;
      // background: rgb(205, 228, 209);
      z-index: 10;
      .number {
        font-size: 50px;
        font-weight: 600;
        color: #fff;
        letter-spacing: 2px;
      }
    }
    .cham-tit {
      font-size: 30px;
      color: #fff;
      margin: 30px 0;
      font-weight: 600;
    }
    .team-grade {
      display: flex;
      position: relative;
      border-radius: 15px;
      overflow: hidden;
      height: 250px;
      .team-img {
        .img-bg {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: #fff;
          overflow: hidden;
          margin: auto;
          margin-top: 40px;
          img {
            margin-top: 18px;
            width: 80px;
            height: 80px;
            // object-fit: cover;
            // object-position: center;
            // border-radius: 50%;
          }
        }
        .team-name {
          font-size: 16px;
          margin-top: 8px;
          color: #fff;
        }
        .view-more {
          color: #fff;
          border: 1px solid #000;
          margin-top: 10px;
          display: inline-block;
          border-radius: 15px;
          padding: 5px 25px 5px 25px;
          cursor: pointer;
        }
        .view-more:hover {
          background: rgba(0, 0, 0, 0.493);
        }
      }
      .team-left {
        width: 50%;
        background: #870014;
        // height: 200px;
      }
      .team-right {
        width: 55%;
        background: #2d3b51;
        // height: 240px;
        position: relative;
        .triangle {
          z-index: 1;
          position: absolute;
          width: 0;
          height: 0;
          border-top: 250px solid #870014;
          border-right: 100px solid transparent;
          top: 0;
          left: 0;
        }
      }
    }
    //final mvp style start
    .final-MVP {
      margin-top: 30px;
      display: flex;
      // margin-bottom: 100px;
      .average {
        background: #fff;
        width: 65%;
        border-radius: 15px;
        box-shadow: 2px 2px 15px #8888886c;
        padding-bottom: 20px;
        .average-num {
          margin: 0 35px;
          .line {
            margin-bottom: 25px;
            .line-info {
              text-align: left;
              display: flex;
              justify-content: space-between;
            }
            .isline {
              display: flex;
              .red-line,
              .red-line-girl {
                width: 50%;
                height: 4px;
                background: #870014;
                border-radius: 2px;
              }
              .black-line,
              .black-line-girl {
                width: 50%;
                height: 4px;
                background: rgb(0, 0, 0);
                margin-left: 5px;
                border-radius: 2px;
              }
            }
            .points-line {
              .red-line {
                width: 40%;
              }
              .black-line {
                width: 60%;
              }
            }
            .points-line {
              .red-line.red-line-girl {
                width: 70%;
              }
              .black-line.black-line-girl {
                width: 30%;
              }
            }
            .assists-line {
              .red-line {
                width: 10%;
              }
              .black-line {
                width: 90%;
              }
            }
            .assists-line {
              .red-line.red-line-girl {
                width: 80%;
              }
              .black-line.black-line-girl {
                width: 20%;
              }
            }
            .rebound-line {
              .red-line {
                width: 50%;
              }
              .black-line {
                width: 50%;
              }
            }
            .rebound-line {
              .red-line.red-line-girl {
                width: 55%;
              }
              .black-line.black-line-girl {
                width: 45%;
              }
            }
          }
        }
      }
      .mvp-info {
        box-shadow: 2px 2px 15px #8888886c;
        margin-left: 30px;
        background: #fff;
        width: 35%;
        border-radius: 15px;
        .info {
          display: flex;
          .img {
            width: 140px;
            height: 140px;
            background: rgb(228, 77, 77);
            border-radius: 50%;
            margin-left: 30px;
            margin-bottom: 25px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              object-position: top;
              border-radius: 50%;
            }
          }
          .info-box {
            width: 200px;
            // background: rgb(162, 181, 223);
            margin: 0 30px;
            .name-grade {
              text-align: left;
              margin-bottom: 15px;
              border-bottom: 2px solid #c5cfe348;
              .en-name {
                font-size: 12px;
              }
              .cn-name {
                font-size: 17px;
                font-weight: 600;
                margin-bottom: 10px;
              }
            }
            .mvp-num {
              display: flex;
              justify-content: space-around;
              .num-box {
                border-right: 2px solid #c5cfe348;
                padding: 0 20px;
                .num-name {
                  font-size: 12px;
                }
                .num {
                  font-size: 22px;
                  font-weight: 600;
                  color: #4e8ac3;
                }
              }
              :nth-child(3) {
                border-right: none;
              }
            }
          }
        }
      }
    }
    .highlght-box {
      margin-bottom: 100px;
    }
    //game-gallery start
    .game-gallery {
      display: flex;
      width: 100%;
      margin: 40px 0;
      // margin-left: 5%;
      .review-game {
        width: 50%;
        background: #fff;
        box-shadow: 2px 2px 15px #8888886c;
        border-radius: 15px;
        padding-bottom: 50px;
        .review-box {
          .re-header {
            display: flex;
            margin: 0 0 15px 35px;
            .logo-img {
              width: 45px;
              height: 45px;
              border-radius: 50%;
              border: 2px solid rgba(184, 182, 182, 0.397);
              padding-top: 8px;
              img {
                width: 100%;
              }
            }
            .re-tit {
              line-height: 50px;
              margin-left: 20px;
              font-weight: 600;
              font-size: 17px;
            }
          }
          .re-img {
            width: 87%;
            height: 270px;
            margin-left: 35px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 10px;
            }
          }
        }
      }
      .gallery {
        width: 50%;
        background: #fff;
        box-shadow: 2px 2px 15px #8888886c;
        border-radius: 15px;
        margin-left: 30px;
        .gallery-header {
          display: flex;
          justify-content: space-between;
          .see-all {
            margin: 30px 35px;
            font-size: 12px;
            cursor: pointer;
            i {
              color: #5aa2d3;
            }
          }
        }
        .gallery-imgbox {
          display: flex;
          width: 88%;
          margin-left: 6%;
          flex-wrap: wrap;
          justify-content: space-between;
          padding-bottom: 30px;
          .gallery-img {
            width: 49%;
            // margin-left: 3%;

            .img {
              margin-top: 5px;
              width: 100%;
              height: 200px;
              border-radius: 10px;
            }
          }
        }
      }
    }
    //media
    .media-exposures {
      background: #fff;
      width: 100%;
      border-radius: 20px;
      padding: 15px 0 40px 0;
      box-shadow: 2px 2px 15px #8888886c;
      .media-box {
        display: flex;
        justify-content: space-around;
        padding: 0 25px;
        .media-img {
          width: 13%;
          // margin-left: 8px;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .champion {
    .champion-con {
      .team-grade {
        height: 300px;
        .grade {
          left: 25%;
          top: 3%;
        }
        .team-left,
        .team-right {
          .team-img {
            margin-top: 90px;
            .img-bg {
              width: 80px;
              height: 80px;
              img {
                width: 60px;
                height: 60px;
                margin-top: 5px;
              }
            }
          }
        }
        .team-right {
          .triangle {
            border-top: 300px solid #870014;
            border-right: 40px solid transparent;
            left: -0.5;
          }
        }
      }
      .final-MVP {
        flex-direction: column;
        .average {
          width: 100%;
        }
        .mvp-info {
          width: 100%;
          margin-left: 0;
          margin-top: 20px;
          padding-bottom: 20px;
          .info {
            justify-content: space-between;
            .img {
              width: 40%;
              background: #fff;
              margin-left: 20px;
              img {
                width: 90px;
                height: 90px;
              }
            }
            .info-box {
              width: 60%;
              .name-grade {
                padding-left: 20px !important;
              }
            }
          }
        }
      }
      .game-gallery {
        flex-direction: column;
        .review-game {
          width: 100%;
          .review-box {
            .re-img {
              width: 90%;
              margin-left: 5%;
            }
          }
        }
        .gallery {
          width: 100%;
          margin-left: 0;
          height: 390px;
          margin-top: 20px;
          .gallery-imgbox {
            .gallery-img {
              .img {
                height: 130px;
                img {
                  object-fit: cover;
                  object-position: center;
                }
              }
            }
          }
        }
      }
      .media-exposures {
        .media-com {
          flex-direction: column;
        }
      }
    }
  }
}
</style>
